export enum ImportMode {
    CSV = 'Csv',
    MICROCAT = 'Microcat',
    CSV_MAZDA = 'Mazda'
}
